import axios from 'axios'
// import { getDeployEnv } from '../../utils'
import { HOSTS } from '../host'
import { getDeployEnv } from '@fe/config'

const env = getDeployEnv()
console.log('env --->', env)

const server = axios.create({
  baseURL: HOSTS[env],
})

server.interceptors.response.use((response) => {
  return response.data
})

export default server
